export const mapValues = (object, iteratee) => {
  const result = {};

  for (const key in object) {
    result[key] =
      typeof iteratee === 'function'
        ? iteratee(object[key], key, object)
        : (result[key] = object[key][iteratee]);
  }

  return result;
};
